import {
  Button,
  ButtonGroup,
  Divider,
  FormLabel,
  IconButton,
  Input,
  Popover,
  PopoverCloseButton,
  PopoverContent,
  PopoverTrigger,
  VStack,
  useDisclosure,
} from '@chakra-ui/react';
import createImagePlugin from '@draft-js-plugins/image';
import { EditorState } from 'draft-js';
import * as React from 'react';

import { CameraIcon } from '@/imports/ui/chakra/feather';

import { ImageUpload } from './components/ImageUpload';

const imagePlugin = createImagePlugin();

export const ImageAdd: React.FC<{
  editorState: EditorState;
  onChange: (state: EditorState) => void;
}> = ({ editorState, onChange }) => {
  const { onOpen, onClose, isOpen } = useDisclosure();
  const [url, setUrl] = React.useState('');

  const onPopoverClose = () => {
    setUrl('');
    onClose();
  };

  return (
    <Popover isOpen={isOpen} onOpen={onOpen} onClose={onPopoverClose}>
      <PopoverTrigger>
        <IconButton
          aria-label="add image"
          icon={<CameraIcon />}
          variant="outline"
          colorScheme="gray"
        >
          Add Image
        </IconButton>
      </PopoverTrigger>
      <PopoverContent p="5">
        <PopoverCloseButton />
        <VStack w="full" spacing="4">
          <VStack w="full" spacing="4" alignItems="flex-start">
            <FormLabel>Choose an Image</FormLabel>
            <ImageUpload
              editorState={editorState}
              modifier={imagePlugin.addImage}
              onChange={onChange}
            />
          </VStack>
          <Divider />
          <VStack w="full" spacing="4" alignItems="flex-start">
            <FormLabel>Paste an Image URL</FormLabel>
            <Input onChange={(e) => setUrl(e.target.value)} value={url} />
            <ButtonGroup w="full" display="flex" justifyContent="flex-end">
              <Button
                variant="outline"
                colorScheme="gray"
                onClick={onPopoverClose}
              >
                Cancel
              </Button>
              <Button
                onClick={() => {
                  onChange(imagePlugin.addImage(editorState, url, {}));
                  onPopoverClose();
                }}
                isDisabled={!url}
              >
                Add
              </Button>
            </ButtonGroup>
          </VStack>
        </VStack>
      </PopoverContent>
    </Popover>
  );
};
